import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '@/lib/analytics';

/**
 * Fires a GA4 + Meta Pixel PageView on every SPA route change.
 * The initial PageView is fired by the loader snippet in index.html, so we
 * skip the first render to avoid double-counting.
 */
export const RouteAnalytics = () => {
  const { pathname, search } = useLocation();
  const first = useRef(true);

  useEffect(() => {
    if (first.current) {
      first.current = false;
      return;
    }
    trackPageView(`${pathname}${search}`);
  }, [pathname, search]);

  return null;
};

export default RouteAnalytics;
